module.exports = __webpack_public_path__ + "img/2W.2.6788b863.jpg";